import { useEffect } from 'react';
import { useLocation } from 'react-router'
import { lang } from '../../App';

function PageTitles() {
    const history = useLocation();
    useEffect(() => {
        let data;
        if(lang === "en"){
            data = titleDataEn[history.pathname]
        } else {
            data = titleData[history.pathname]
        }
        if(data) {
            document.title = data.title;
            let meta = document.querySelector('meta[name=description]');
            let link = document.querySelector('link[rel=canonical]');
            if(link){
                link.remove();
            }
            if(meta){
                meta.remove();
            }
            let desc = document.createElement("meta");
            desc.name = 'description';
            desc.content = data.desc;

            generateRichSchema();

            document.getElementsByTagName('head')[0].appendChild(desc);
            if(data.canonical.length > 0){
                let cano = document.createElement("link");
                cano.rel = 'canonical';
                cano.href = data.canonical;
                document.getElementsByTagName('head')[0].appendChild(cano);
            }
        } else {
            if(
                history.pathname.search("/podcast/") !== -1
            ){
                return;
            }
            if(lang === "en"){
                document.title = 'Podkadeh';
            } else {
                document.title = 'پادکده';
            }
            let meta = document.querySelector('meta[name=description]');
            let link = document.querySelector('link[rel=canonical]');
            if(link){
                link.remove();
            }
            if(meta){
                meta.remove();
            }
        }
        // generateRichSchema();
        return () => {
        }
    }, [history]);

    return (null);
}

export default PageTitles;
export function ChangeTitlePage (title, description, canonical = "") {
    document.title = title;
    let meta = document.querySelector('meta[name=description]');
    if(meta){
        meta.remove();
    }
    let link = document.querySelector('link[rel=canonical]');
    if(link){
        link.remove();
    }
    let desc = document.createElement("meta");
    desc.name = 'description';
    desc.content = description;
    document.getElementsByTagName('head')[0].appendChild(desc);
    if(canonical.length > 0){
        let cano = document.createElement("link");
        cano.rel = 'canonical';
        cano.href = canonical;
        document.getElementsByTagName('head')[0].appendChild(cano);
    }
}
export function MakeChangeCanonical(canonical = ""){
    if(canonical.length > 0){
        let link = document.querySelector('link[rel=canonical]');
        let changeCano = false;
        if(link && canonical !== link.href){
            changeCano = true;
        } else if(!link){
            changeCano = true;
        }
        if(changeCano){
            if(link){
                link.remove();
            }
            let cano = document.createElement("link");
            cano.rel = 'canonical';
            cano.href = canonical;
            document.getElementsByTagName('head')[0].appendChild(cano);

            // yektanet reload
            // let yektanet = document.getElementById("yn_ad_script");
            // let yektanetNew = document.createElement("script");
            // if(yektanet && window["yektanet_podkadeh.com_native-podkadeh.com-38968_is_loaded"] && link && window.isRefreshYektanet){
            //     yektanetNew.async = false;
            //     yektanetNew.type = yektanet.type;
            //     yektanetNew.src = yektanet.src;
            //     yektanetNew.id = "yn_ad_script";
            //     yektanetNew["data-experiment"] = yektanet["data-experiment"];
            //     yektanetNew["data-variant"] = yektanet["data-variant"];
            //     yektanet.remove();
            //     window["yektanet_podkadeh.com_native-podkadeh.com-38968_is_loaded"] = false
            //     document.getElementsByTagName('head')[0].appendChild(yektanetNew);
            //     window.isRefreshYektanet = true;
            // } else {
            //     window.isRefreshYektanet = true;
            // }
        }
    } 
}

export const generateRichSchema = (profileData, articleData, breadcrumbData) => {
    // <script type="application/ld+json"></script>
    let mainData = document.querySelector("script[type='application/ld+json']");
    if(mainData){
        mainData.remove();
    }
    let newData = document.createElement("script");
    newData.type = "application/ld+json";

    let webSite = {
        "@type":"WebSite",
        "@id":"https://podkadeh.com/#website",
        "url":"https://podkadeh.com/",
        "name":"پادکده",
        "description":"بساز پلتفرمی نوآورانه برای میزبانی پادکست است که با ارائه ابزارها و فناوری‌های پیشرفته، به شما کمک می‌کند تا از پادکستتان درآمدزایی کنید. مزایای استفاده از بساز شامل درج محتوای پویا، سرعت و آپ‌تایم بی‌نظیر و انتشار آسان در تمام پلتفرم‌ها می‌شود.",
        "publisher":{"@id":"https://podkadeh.com/#organization"},
        "alternateName":"Podkadeh",
        "inLanguage":"fa-IR"
    }
    let org = {
        "@type":"Organization",
        "@id":"https://podkadeh.com/#organization",
        "name":"پادکده",
        "alternateName":"Podkadeh",
        "url":"https://podkadeh.com/",
        "logo":{
            "@type":"ImageObject",
            "inLanguage":"fa-IR",
            "@id":"https://podkadeh.com/#/schema/logo/image/",
            // "url":'data:image/png;base64,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',
            // "contentUrl":'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOYAAABYCAYAAADhqou+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAu1SURBVHgB7Z3NctvIEcd7QEu2lUOYJ1j4CSzfNrJThi6J5RwiPYGpJ7B8SJWtPYg6+KMqB3OfQNQTSHvYyNmL6IrtSlUO5j6B4TfgSdJaJma7iYEN0QQwQwwgAuxfFUoUBOFDmj+6p7tnRgDDlMTj749ccMATQtwUElzctYyfmxJkEyqMADHAZ/AFwCAA6EMQvD69+luv09sYwJQIYJgC2fIOmkuflh4CyBa2NhfmCBRXT0q5f7J4dmgqUhYmUwhkHRsNsScBPGB8kKIbBMH+i/+t+Tq/wMJkrEIW8g/nSzvo2m0BMw4KVO4+e7fWzTqQhclYg6yk44jjeXNZp6B7snD6KM29ZWEyVthe+QUDOfK46oGcEvGDoVxNcm1ZmExuWJRTkyhOBxgmB+S+siinxnUa4oD65eM/YGEyU0MNivqULMpcLF/HYNn4ThYmMzUUfeVAT34ERrCf/OXf6xf3McwUjCKwDfEBGFv4GKm9FUVq2WIyU0HFA8DYxF36dO1L7pctJmPM9srPyyAa74GxjBicLJzcIKvJFpMxRzQeAlMAsnn9tyWPPrEwGWMEiHVgisGRo5ceu7KMERj08TDocwwlIzE4ImXwkzMaYiUeiIKiwWpEyGtJ55firig96hy6s1eAYQzAvGXp1hLzpPvP3661YrvaT24fddFyPwCbCLn79M1aO/o2HD8qjssVp2xe+3xtmV1ZxghspDehVNBCDqE9vvfqwtkWDVAGS5ClfBYTJUGlctKRm1AyYihYmIwpYhlKBJPv/Um1pO1Rvk/6YAlyXyftv3blrA8lIxy4ycJktGl7B7M2DYg1i5lEO8f0INOCfWi2mIw+nz4tusAUDnoJTRYmo00QOFysXg5u7aOy2HegyF0Ltw0hROluSRJ4X9TIExs63qsPzNxSa2Fi46fhNG317TF+vzpD4uzglhjuV/fagxpCEdChlPujzwI862mPr3QDDOoIKZp40YeiQiNhailMZY0O4OIMbRRNnDVxzh9SHD5997eN2J7u9p0jmkVuBywiAR49f3uvE9vVKST3WRC162Oi8Fz8QgXW3oQfR+J0gbkUgiB4NL6P8oeCJkq2BFUJjYlyBOU+oSJkClNZn0qA9+pBKEo35bBltTHl4ydNPhUE8lewBLnKk/aPUh8SfKgAqcJUfbT3RVgYErzN8+K5qPiXajizXiS76MoeAsPMMInCjAVOXLDs/uG5yGKRZTuAnCiBv4QwmJIFibINFqC/B270d2kBw1hmojDHopmEC5bEGbNsLm7L+H0bpkTdD51Lp+9waEuUCvobebjt4X3scb+Vsck3wpwgyggXt4Np+5yRhYHQssXPsaMs6DTQ+XR/d99Wf1lZyVZsF31m6zmnjPq0Uu7SKBiwxIV0SYooI6ZKOaigDLmtScKg+WNugTmuwbEH6l7ovvtqo8LlvkkyX4l7J+FeyHLS6ItdTsnMCVJuPo2tRfL4+6N2o+G8z1tT7Hw9/+hELY3ficSpdWF1HAkv7fhcLq0hdB8ehO4vifUDXpu2luYzkSjdlJ/Ted/n8AKMwWutq/tP2riUrhi64wsEUdQZI8y7kJMvwlRveN2xZ9riNDjvziX201wIXx6pglL3p9OfddW5rCbNU6B++17K9kdg7JMwVAz/77mj/nGL6UL4T9TFRJw9/PIjZHPZUyK6EArKS/i56SRUbWWNXWAYA0bCjEU3XTCDxKmb8mgDZCZ3PbyXWajOOJgkJnzBUNWKqZviQuguV6IUjJkNIouZ1W9KQ0tMBbm0JBRyG/pgl6hf/A0q5XIDwLiCpMOWk9HFUY2lBfnQ6ktpurSJophwvg5uNJyLIrp/wm0VQrFS2DqvWOmF813CdX3cSJw67nkEPdcseANMBSCLaaOxNFP6ZeO0oQCXliwyCV+JtUVixY2m54zESiLqgRkbGdfcUsf4oMcDjpAyOpAws2Y9I8uj47qtgwZlR2ljYt3CbVWJlSwsiTXLqnqQfX5ypUn8OsllEqULDJMBCTMt3+bjtqoS8NT40pLmLmhi26U1Ba/fV2IlgaaJU2uqRuXatiAUexal5TeZ6kLCTHOtelEFixJnWiM2zZV1NI7xSsgFDsASJHbIcH8NYJd3jqGSPGqYSY2AKkqovMxXbqULGai+pgfZfAd6tNW1abyeNRHFcLMOoMoa0Ld0WVZW9xle4nX/oXmsB0ytIGH6kNzoSLBURBAdk/YWjwa6eqAZpTWgBZeDr76SMG3lIX31tZ9xThfsPDcFxT4CUynIlf0p4xgXQrFluVY9qB/WRtUrqC8adQdyl21pUtZ15hF30k6xkL9OmoTZhfz4NZ0VQKcfbMKXyK3qs/egeKwNRWLGEM7D0cJDMba8g6YYOi8hJ1dU/5EipHkWI81dTT+DdC3P7erDty9BiuLqTIcyLd26ToE5G8gmLUm4vXK0GwRknGRTnDs7YGGazGg8Zhs3CjS4YA7NDNCFeuGDXupDFwr4bIwLndxaCq7hx9xv2An4UM8X5qzh4j9yz2nQR3vLzY5qZVVKhPKUPpjRA/2hYjpQQzIpcysC6gPanHt2oM43MdWkUiw2XwJE9Aw+MJUkPh7Th7AiRqdPQo1tV1XS2GjAPQgbUluVueneh01GzwT2GjSdr4vbjSRRRihxUnVV3meO/i+3WJTV5sLUIkpkLTWbAAnkLnxNpURTctDg0E6KIHugjw+hKzwYu4++uo8t+DoPbFH9sC9TjaQ80yGYeRN07KHJS0sJKfrbR8+si84zMBVi4hIJqpFswRSoYEMPLKAaWQ8uORWjIs6lRJ3V396HWqY5ROLLFZ+7lFkW8Dq0xifMOrwMH6ON4wQ5rbFsPr5z5I3vVSkHEw8hA7FOaYsJ1/FmbOHdBMSAhcloEwRObjfZkWIvnvsjAWHK4QCsrsQlm9c/Xb9wHfrsOOKyp67RRA5qvz5mHchaSzMJ2wEgmgFu+/YryImLQvzww+1XvdF352K5CCsmBKw7DcfD6/Rl+LezaJGLBZMuPguzGowmPgNz7CXWImhRHgvWTX4pvC+uv6cE70HFGMrgV3ZlGSNkwpSNjE1En4XJGJKek2XyMzwPWJiMGTYmM2aSoUV3//X/v7MwGTMoACRLzCtLECkz49uL5OJ1Jg5w3175udSgUbToLguzGvgQlvdFWy/huN7YcYUgSu1nyuaTP7/6pthle+U/OzZTLBTF/edEEV4pa5mLEcEwXPfEftSOKRw1fcukKO1mGSN92ph7PD9f+lBysr6LjXafhlY5TuMuXnuqyrR0xABk8CgawuU4zkNZYlSXrOXTt/dW1Wemaly2MIntlaM2mplSrUndCYRcffFmrUef2ZVlpmJx8awjpfEwQSaZbiRKgoXJTEW7tzGARmB7HOlcQpHYqG8ZwcJkpub5f+8fYmfosge2Vx6axYKi3fF93MdkcvPk9qtjwXPbToeQu8/erLXHd7PFZHJzdeGUZp/niiBTEkRJsDCZ3FB/c3HhdJXdWgNSRDn6MTCMRbbvYBpFcholCQr0SCE34xHYSbDFZKxCVgAjjDckSJ5oeoxABD+eLpzeyhIlwRaTKQyaRkRIaAkQttZ9qSBiEMjhPqqyMx55Tf0tYJiCGU3x4YDXEOJBWJRe91W1xUCAPBxK+fps8eywQzlf0zMAw5TM9sovy7Lx2YXPjks1qQEKtSEaD8qqvRWWC/wxD/lRSjGAK4Evz0XfxDImwcJkZoIfMBdadME4BV6EdDaevfvrzKd2OPjDzAVR4KUKoiR4Mi6m1nxNT9zvQYVgi8nUFpP0xKzBFpOpHVW1knHYYjK1ospWMg5bTKYmYCJfBBtVtpJx2GIy1UeKw5OFkxtVt5Jx2GIyFUYMpDPcHA3YrhksTGYmkBIGJuUuNKPccBhsvnh734cawsJkZoWPeoehlQS5++ztvQ7UGO5jMjNB4GQvvUBWMhgGt57XXJQE18oyM0PyIOvQSs6DICNYmMxM8XjlqNUQgmZAX1bDp/rDody0MWKjSvwOW6nYhwVk/swAAAAASUVORK5CYII=',
            "caption":"بساز پلتفرمی نوآورانه برای میزبانی پادکست است که با ارائه ابزارها و فناوری‌های پیشرفته، به شما کمک می‌کند تا از پادکستتان درآمدزایی کنید. مزایای استفاده از بساز شامل درج محتوای پویا، سرعت و آپ‌تایم بی‌نظیر و انتشار آسان در تمام پلتفرم‌ها می‌شود.",
            "width":230,
            "height":88,
        },
        "image":{
            "@id":"https://podkadeh.com/#/schema/logo/image/"
        },
        "sameAs":[
            "https://instagram.com/podkadeh"
        ]
    }
    const innerContent = {
        "@context":"https://schema.org",
        "@graph":[]
    }
    if(profileData){
        innerContent['@graph'].push(profileData)
    }
    if(articleData){
        innerContent['@graph'].push(articleData)
    }
    if(breadcrumbData){
        innerContent['@graph'].push(breadcrumbData)
    }
    innerContent['@graph'].push(
        webSite,
        org
    )
    newData.innerText = JSON.stringify(innerContent)
    document.getElementsByTagName('head')[0].appendChild(newData);
}

let valsdkla = {
    "@context":"https://schema.org",
    "@graph":[
        {
            "@type":"WebPage",
            "@id":"https://dailypulse.ir/",
            "url":"https://dailypulse.ir/",
            "name":"خانه | Daily pulse | حال خوبت رو با دیلی پالس تجربه کن",
            "isPartOf":{
                "@id":"https://dailypulse.ir/#website"
            },
            "about":{
                "@id":"https://dailypulse.ir/#organization"
            },
            "primaryImageOfPage":{
                "@id":"https://dailypulse.ir/#primaryimage"
            },
            "image":{
                "@id":"https://dailypulse.ir/#primaryimage"
            },
            "thumbnailUrl":"https://dailypulse.ir/wp-content/uploads/2024/02/Group-6.png",
            "datePublished":"2021-05-03T11:14:32+00:00",
            "dateModified":"2024-06-10T11:21:52+00:00",
            "description":"بساز پلتفرمی نوآورانه برای میزبانی پادکست است که با ارائه ابزارها و فناوری‌های پیشرفته، به شما کمک می‌کند تا از پادکستتان درآمدزایی کنید. مزایای استفاده از بساز شامل درج محتوای پویا، سرعت و آپ‌تایم بی‌نظیر و انتشار آسان در تمام پلتفرم‌ها می‌شود.",
            "breadcrumb":{
                "@id":"https://dailypulse.ir/#breadcrumb"
            },
            "inLanguage":"fa-IR",
            "potentialAction":[
                {
                    "@type":"ReadAction",
                    "target":[
                        "https://dailypulse.ir/"
                    ]
                }
            ]
        },{
            "@type":"ImageObject",
            "inLanguage":"fa-IR",
            "@id":"https://dailypulse.ir/#primaryimage",
            "url":"https://dailypulse.ir/wp-content/uploads/2024/02/Group-6.png",
            "contentUrl":"https://dailypulse.ir/wp-content/uploads/2024/02/Group-6.png",
            "width":511,
            "height":548
        },{
            "@type":"BreadcrumbList",
            "@id":"https://dailypulse.ir/#breadcrumb",
            "itemListElement":[
                {"@type":"ListItem","position":1,"name":"خانه"}
            ]
        },{
            "@type":"WebSite",
            "@id":"https://dailypulse.ir/#website",
            "url":"https://dailypulse.ir/",
            "name":"Daily pulse | حال خوبت رو با دیلی پالس تجربه کن",
            "description":"حال خوبت رو با دیلی پالس تجربه کن",
            "publisher":{"@id":"https://dailypulse.ir/#organization"},
            "alternateName":"Daily pulse",
            "potentialAction":[
                {
                    "@type":"SearchAction",
                    "target":{
                        "@type":"EntryPoint",
                        "urlTemplate":"https://dailypulse.ir/?s={search_term_string}"
                    },
                    "query-input":"required name=search_term_string"
                }
            ],
            "inLanguage":"fa-IR"
        },{
            "@type":"Organization",
            "@id":"https://dailypulse.ir/#organization",
            "name":"Daily pulse | حال خوبت رو با دیلی پالس تجربه کن",
            "alternateName":"Daily pulse",
            "url":"https://dailypulse.ir/",
            "logo":{
                "@type":"ImageObject",
                "inLanguage":"fa-IR",
                "@id":"https://dailypulse.ir/#/schema/logo/image/",
                "url":"https://dailypulse.ir/wp-content/uploads/2023/12/cropped-myLogoG.png",
                "contentUrl":"https://dailypulse.ir/wp-content/uploads/2023/12/cropped-myLogoG.png",
                "width":1080,
                "height":537,
                "caption":"Daily pulse | حال خوبت رو با دیلی پالس تجربه کن"
            },
            "image":{
                "@id":"https://dailypulse.ir/#/schema/logo/image/"
            },
            "sameAs":[
                "https://instagram.com/dailypulse.ir"
            ]
        }
    ]
}



const titleData = {
    '/': {
        title: 'پادکده؛ بساز',
        desc: 'بساز پلتفرمی نوآورانه برای میزبانی پادکست است که با ارائه ابزارها و فناوری‌های پیشرفته، به شما کمک می‌کند تا از پادکستتان درآمدزایی کنید. مزایای استفاده از بساز شامل درج محتوای پویا، سرعت و آپ‌تایم بی‌نظیر و انتشار آسان در تمام پلتفرم‌ها می‌شود.',
        canonical: "https://podkadeh.com/"
    },
    '/besaz-landing': {
        title: 'پادکده کجاست؟',
        desc: 'معرفی پادکده و سرویس‌های آن را از زبان بنیان‌گذاران و کارمندان آن بشنوید. ما در تمام ساعت‌های کاری خود تلاش می‌کنیم تا تجربه‌ای لذت‌بخش برای سازندگان و شنوندگان پادکست فارسی خلق کنیم.',
        canonical: "https://podkadeh.com/besaz-landing"
    },
    '/termsofservice': {
        title: 'پادکده؛ شرایط و قوانین',
        desc: '',
        canonical: "https://podkadeh.com/termsofservice"
    },
    '/aboutus': {
        title: 'پادکده؛ درباره ما',
        desc: '',
        canonical: "https://podkadeh.com/aboutus"
    },
    '/contactus': {
        title: 'پادکده؛ تماس با ما',
        desc: '',
        canonical: "https://podkadeh.com/contactus"
    },
    '/podcasts': {
        title: 'پادکده؛ آرشیو پادکست فارسی',
        desc: 'مجموعه ای از بهترین پادکست های فارسی',
        canonical: "https://podkadeh.com/podcasts"
    },
}

const titleDataEn = {
    '/': {
        title: 'Podkadeh - Besaz',
        desc: 'Podkadeh - Besaz'
    },
    '/dynamic-ads': {
        title: 'Podkadeh - Dynamic Ad Solution',
        desc: 'Podkadeh - Dynamic Ad Solution'
    },
    '/besaz-landing': {
        title: 'Where is Podkadeh?',
        desc: 'Podkadeh - Besaz'
    },
    '/termsofservice': {
        title: 'Podkadeh - Terms and conditions',
        desc: 'Podkadeh - Terms and conditions'
    },
    '/aboutus': {
        title: 'Podkadeh - About us',
        desc: 'Podkadeh - About us'
    },
    '/contactus': {
        title: 'Podkadeh - Contact us',
        desc: 'Podkadeh - Contact us'
    },
}